<template>
    <div>
        <b-row>
            <b-col cols="12" md="4" lg="3">
                <app-autocomplete
                    placeholder="Cliente"
                    :items="clients"
                    v-model="selectedClient"
                ></app-autocomplete>
            </b-col>
            <b-col cols="12" md="3" lg="2">
                <b-form-select
                    :options="yearList"
                    v-model="selectedYear"
                    text-field="name"
                    value-field="id"
                    label="Año"
                    @change="validateForMonth"
                ></b-form-select>
            </b-col>
            <b-col cols="12" md="3" lg="2">
                <b-form-select
                    :options="monthList"
                    v-model="selectedMonth"
                    text-field="name"
                    value-field="id"
                    label="Mes"
                    :disabled="!selectedYear"
                ></b-form-select>
            </b-col>
            <b-col cols="12" md="2">
                <b-btn
                    variant="primary"
                    block
                    @click="loadData"
                    :disabled="!selectedClient"
                    >Consultar</b-btn
                >
            </b-col>
        </b-row>
        <b-row v-if="!!selectedClient" class="my-4">
            <b-col cols="12" class="text-center">
                <app-title :text="reportTitle" />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <app-client-figures
                    :selected-client="selectedClient"
                    :year="selectedYear"
                    :month="selectedMonth"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <app-client-charts
                    :selected-client="selectedClient"
                    :year="selectedYear"
                    :month="selectedMonth"
                />
            </b-col>
        </b-row>
    </div>
</template>
<script>
import Autocomplete from '../../../../../components/UI/Controls/AutocompleteV2/Autocomplete'
import ClientCharts from './ClientCharts/ClientCharts'
import ClientFigures from './ClientFigures/ClientFigures'
import { mapGetters } from 'vuex'
export default {
    components: {
        appClientCharts: ClientCharts,
        appAutocomplete: Autocomplete,
        appClientFigures: ClientFigures,
    },
    data: () => ({
        selectedClient: '',
        selectedYear: '',
        selectedMonth: '',
    }),
    computed: {
        ...mapGetters(['clients', 'years', 'months']),
        yearList() {
            return [{ id: '', name: 'Seleccione un año' }, ...this.years]
        },
        monthList() {
            return [{ id: '', name: 'Seleccione un mes' }, ...this.months]
        },
        reportTitle() {
            if (!this.selectedClient) return ''
            const parts = []

            parts.push(`Cliente: ${this.selectedClient.name}`)
            !!this.selectedYear && parts.push(' [')
            !!this.selectedYear && parts.push(`${this.selectedYear}`)

            !!this.selectedMonth && parts.push(' - ')
            !!this.selectedMonth && parts.push(`${this.selectedMonth}`)

            !!this.selectedYear && parts.push(']')

            return parts.join('')
        },
    },
    methods: {
        validateForMonth() {
            !!this.selectedYear && (this.selectedMonth = '')
        },
        loadData() {
            this.$bus.$emit('pqr-client-figures.load')
            this.$bus.$emit('pqr-client-charts.load')
        },
    },
    created() {
        this.load('clients')
        this.load('years')
        this.load('months')
    },
}
</script>
